import { createStoreProvider, isNullOrUndefined, StoreBase } from "@eblsoft/react-toolkit";
import { action, observable, runInAction } from "mobx";
import NotificationStore from "Stores/NotificationStore";
import { ValidationStore } from "Stores/ValidationStore";
import { ISimpleDocumentDetailCoreProps } from "./SimpleDocumnetDetail";
import { DocumentStatus } from "Models/DocumentStatus";
import AdminSimpleDocumentAdapter from "Adapters/AdminAdapter/AdminSimpleDocumentAdapter";
import AdminDocumentApiAdapter from "Adapters/AdminAdapter/AdminDocumentApiAdapter";

export default class SimpleDocumentStore extends StoreBase<ISimpleDocumentDetailCoreProps> {
    public id: number | null = null;
    @observable.ref public identifier: string = "";
    @observable.ref public status: DocumentStatus | null = null;
    @observable.ref public validTo: moment.Moment | null = null;
    @observable.ref public lastConfirmedValidTo: moment.Moment | null = null;
    public images: string[] = [];

    @observable.ref public isAuthorized = AdminDocumentApiAdapter.getDocumentReviewToken() != null;
    @observable.ref public tfaCode: string = "";
    @action.bound public setTfaCode(value: string) { this.tfaCode = value; }
    public readonly authenticateAsync = this.async(async () => {
        const isOk = await AdminDocumentApiAdapter.authorizeAsync(this.tfaCode);
        if (!isOk) {
            NotificationStore.error("Hibás hitelesítő kód");
            return;
        }
        runInAction(() => {
            this.isAuthorized = true;
        });
        await this.vLoadAsync();
    });

    public readonly validationStore = new ValidationStore();

    @action.bound
    public setIdentifier(value: string) {
        this.identifier = value;
    }

    @action.bound
    public setSimpleDocumentStatus(value: DocumentStatus) {
        this.status = value;
    }


    @action.bound
    public setValidTo(value: moment.Moment | null) {
        this.validTo = value;
    }

    public readonly vLoadAsync = this.async(async () => {
        if (!isNullOrUndefined(this.props.simpleDocumentId) && this.isAuthorized) {
            const result = await AdminSimpleDocumentAdapter.getDetailsAsync(AdminDocumentApiAdapter.getDocumentReviewToken()!, this.props.simpleDocumentId!);
            runInAction(() => {
                this.id = this.props.simpleDocumentId ?? null
                this.identifier = result?.identifier ?? "";
                this.status = result?.status ?? "";
                this.validTo = result?.validTo ?? null;
                this.images = result?.images ?? [];
                this.lastConfirmedValidTo = result?.lastConfirmedValidTo;
            });
        }
    });

    public saveAsync = this.async(async () => {

        if (!this.isAuthorized) {
            return false;
        }

        if (this.status === null || (this.status == DocumentStatus.Confirmed && !this.validationStore.isValid())) {
            NotificationStore.error("Hibás vagy kitöltetlen adatok");
            return false;
        }

        await AdminSimpleDocumentAdapter.updateSimpleDocumentAsync(
            AdminDocumentApiAdapter.getDocumentReviewToken()!,
            this.id!,
            this.identifier,
            this.validTo,
            this.status);

        NotificationStore.success("Sikeres mentés");
        return true;
    });
}



const { ContextComponent: SimpleDocumentDetailStoreContext, StoreProvider: SimpleDocumentDetailStoreProvider, useStore: useSimpleDocumentDetailStore, withStore: withSimpleDocumentDetailStore } =
    createStoreProvider<ISimpleDocumentDetailCoreProps, SimpleDocumentStore>(() => new SimpleDocumentStore());

export {
    SimpleDocumentDetailStoreContext,
    SimpleDocumentDetailStoreProvider,
    useSimpleDocumentDetailStore,
    withSimpleDocumentDetailStore
};